import { Box, Typography } from "@mui/material";

const LogoIcon = () => {
  return (
    <Box
      sx={{
        display: "flex",
        "& p": {
          fontWeight: "bold",
          margin: "0 2px",
          fontSize: "36px",
          textTransform: "uppercase",
        },
      }}
    >
      <Typography
        sx={{
          color: "#2A4365",
        }}
      >
        Astrology
      </Typography>
      <Typography
        sx={{
          color: "#FCCD2A",
        }}
      >
        CMS
      </Typography>
    </Box>
  );
};

export default LogoIcon;
